import gql from 'graphql-tag';

import {
  FirstToDonateEnrolmentFragment,
  PageType,
} from '../../types/__generated__';
import IconType from '../constants/iconTypes';
import { PageMetaContext } from '../context';
import { useNotNullableContext } from './useNotNullableContext';
import { usePageOwner } from './usePageOwner';
import usePageQuery, { buildQuery } from './usePageQuery';

const FRAGMENT = buildQuery(gql`
  fragment FirstToDonateEnrolment on Page {
    targetWithCurrency {
      value
    }
    donationSummary {
      totalAmount {
        value
      }
    }
    reason {
      icon
    }
  }
`);

// B2C_029 - First to donate
// Can be removed when experiment has ended
export function useShouldSkipFirstToDonateEnrolment(): boolean {
  const { isPageOwner } = usePageOwner();
  const { pageType } = useNotNullableContext(PageMetaContext);

  const { data = null } = usePageQuery<FirstToDonateEnrolmentFragment>(
    FRAGMENT,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  if (!data) return true;

  const { targetWithCurrency, donationSummary, reason } = data;

  const targetValue = targetWithCurrency?.value;
  const donationValue = donationSummary?.totalAmount?.value ?? 0;
  const isInMemory = reason?.icon === IconType.InMemoryIcon;

  return (
    isPageOwner ||
    pageType.toUpperCase() !== PageType.Fundraising ||
    !targetValue ||
    donationValue > 0 ||
    isInMemory
  );
}
